export const TOKEN_KEY = '@stratolit/token';

/**
 * Armazena o token na sessão ou no local storage, dependendo do parâmetro de persistência.
 *
 * @param {string} token - O token de autenticação.
 * @param {boolean} persist - Define se o token deve ser persistido no `localStorage` (true) ou no `sessionStorage` (false).
 */
export const setTokenOnSession = (token, persist) => {
  if (persist) localStorage.setItem(TOKEN_KEY, token);
  else sessionStorage.setItem(TOKEN_KEY, token);
};

/**
 * Remove o token da sessão e do local storage.
 */
export const setTokenOffSession = () => {
  localStorage.clear();
  sessionStorage.clear();
};

/**
 * Obtém o token de autenticação da sessão ou do local storage.
 *
 * @returns {string|null} - Retorna o token, caso esteja armazenado, ou null caso contrário.
 */
export const getToken = () => sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);

/**
 * Verifica se o usuário está autenticado, ou seja, se há um token armazenado.
 *
 * @returns {boolean} - Retorna true se o usuário estiver autenticado, ou false caso contrário.
 */
export const isAuthenticated = () =>
  sessionStorage.getItem(TOKEN_KEY) !== null || localStorage.getItem(TOKEN_KEY) !== null;
